import React, { useEffect, useRef, useState } from 'react';
import ReactDatepicker from 'react-datepicker';
import { Field, FieldLabel, FieldProps } from '../field/field';
import Icon, { COLORS, ICONS } from '../icon';

import "react-datepicker/dist/react-datepicker.css";

import './date-picker.scss';


function getStart(initialDate?: Date): Date {
	const start = initialDate || new Date();
	if (!initialDate) {
		start.setHours(0);
		start.setMinutes(0);
		start.setSeconds(0);
	}
	return start;
}

export interface DatepickerProps extends FieldProps<Date> {
	onChange?: (date: Date) => void;
	defaultValue?: Date;
	popperPlacement?: string;
	onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
	value?: Date;
	portalId?: string;
	persistent?: boolean;
}

// eslint-disable-next-line react/display-name
const Datepicker: React.FC<DatepickerProps> = (props: DatepickerProps): JSX.Element => {
	const {
		label,
		onChange,
		onBlur,
		name,
		defaultValue: initialDate,
		popperPlacement,
		value,
		required,
		portalId,
	} = props;
	const [selectedDate, setSelectedDate] = useState(getStart(initialDate));
	const picker = useRef<ReactDatepicker | null>(null);

	useEffect(() => {
		setSelectedDate(getStart(value));
	}, [value]);

	// keep state synced with parent
	useEffect(() => {
		setSelectedDate(getStart(initialDate));
	}, [initialDate]);

	function dateChange(date: Date) {
		setSelectedDate(date);
		onChange && onChange(date);
	}

	function focusField() {
		picker.current?.setFocus();
	}

	return (
		<Field {...props}>
			<FieldLabel label={label} required={required} />
			<div className="datepicker" onClick={focusField}>
				<div className="datepicker-input">
					<ReactDatepicker
						ref={picker}
						selected={selectedDate}
						onChange={dateChange}
						onBlur={onBlur}
						name={name}
						showTimeSelect
						timeFormat="hh:mm aa"
						dateFormat={'MM/dd/yyyy hh:mm aa'}
						timeIntervals={5}
						timeCaption={'Start time'}
						minDate={getStart()}
						popperPlacement={popperPlacement ? popperPlacement : undefined}
						portalId={portalId}
						popperClassName={`${portalId ? 'date-with-portal' : ''}`}
					/>
				</div>
				<Icon name={ICONS.CALENDAR} size={15} color={COLORS.DEFAULT_GRAY} />
			</div>
		</Field>
	);
};

export default Datepicker;
